import baseLoadable from '@loadable/component';
import React from 'react';
import { LoaderWithLogo } from '../app/1_atoms/LoaderWithLogo/LoaderWithLogo';
export const loadable = (func, options) => baseLoadable(func, Object.assign({ fallback: React.createElement(LoaderWithLogo, null) }, options));
